import React from "react";
import { features } from "../mock";

const Features = () => {
  return (
    <section style={{ background: "var(--tan)" }}>
      <div className="max-w-[1360px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-3">
        {features.map((f, i) => {
          const last = i === features.length - 1;
          return (
            <div
              key={f.no}
              className={`py-7 md:py-16 md:px-10 first:md:pl-0 last:md:pr-0 flex items-start gap-4 md:block ${!last ? "border-b md:border-b-0 md:border-r" : ""}`}
              style={{ borderColor: "rgba(89,26,32,0.15)" }}
            >
              <span className="font-mono2 shrink-0 mt-1 md:mt-0" style={{ fontSize: "0.72rem", color: "var(--wine-soft)", opacity: 0.7 }}>{f.no}</span>
              <div>
                <h3 className="font-display text-2xl md:text-3xl md:mt-4" style={{ color: "var(--wine)" }}>{f.title}</h3>
                <p className="font-body mt-1.5 md:mt-3 max-w-md md:max-w-xs leading-relaxed" style={{ color: "var(--ink)", opacity: 0.75 }}>{f.text}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Features;
